import { useState, useEffect } from 'react';
import { fetchReferenceValues, getOptionsFromReference } from '../services/referenceService';

export const useReferenceOptions = (optionSet, defaultValueKey = 'id', labelKey = 'label') => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadOptions = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchReferenceValues(optionSet);
        const formattedOptions = getOptionsFromReference(data, labelKey, defaultValueKey);
        setOptions(formattedOptions);
      } catch (err) {
        setError(err.message);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    if (optionSet) {
      loadOptions();
    }
  }, [optionSet, defaultValueKey, labelKey]);

  return { options, loading, error };
};